import { ReactNode } from 'react'

interface ShimmerSkeletonProps {
  children?: ReactNode
  className?: string
}

export const ShimmerSkeleton = ({ children, className = '' }: ShimmerSkeletonProps) => {
  return (
    <div className={`relative overflow-hidden bg-gray-200 ${className}`}>
      <div 
        className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent"
        style={{ width: '200%' }}
      />
      {children}
    </div>
  )
}